import React from "react";
import { Modal } from "antd";
import RoleForm from "./RoleForm";

const RolePopup = ({
  isModalOpen,
  editingRole,
  closeModal,
  handleUpdateList,
}) => {
  const handleList = () => {
    handleUpdateList();
    closeModal();
  };
  return (
    <Modal
      title={editingRole ? "Edit Role" : "Add New Role"}
      open={isModalOpen}
      onCancel={() => {
        closeModal();
      }}
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%',
      }}
      footer={null}
      maskClosable={false}
    >
      <RoleForm editingRole={editingRole} handleUpdateList={handleList} />
    </Modal>
  );
};

export default RolePopup;
